import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export const MOUNTED_STORAGE_PROMOTION = 'mounted-storage';

export type PromotionsGetLinkParams =
  /**
   * Promotions
   * /promotions/mounted-storage
   */
  {
    page: 'promotions';
    promotion: typeof MOUNTED_STORAGE_PROMOTION;
  };

export const PROMOTION_SEARCH_PARAM = 'promotion';

export const getPromotionLandingHref = (
  promotion: PromotionsGetLinkParams['promotion'],
  accountId?: string
): ValidHref =>
  createUrl({
    pathname: '/',
    searchParams: {
      [PROMOTION_SEARCH_PARAM]: promotion,
      ...(accountId ? { a: accountId } : {}),
    },
  });

export const getLinkForPromotions = ({
  promotion,
}: PromotionsGetLinkParams): ValidHref => {
  return createUrl({ pathname: `/promotions/${promotion}` });
};

export const isPromotionsPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');
  return parts[1] === 'promotions';
};
